import React, { useEffect, useState, useRef, useMemo, useCallback } from "react"
import { withRouter, Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  InputGroup,
  Badge,
} from "reactstrap"
import Select from "react-select"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import * as Yup from "yup"
import { useFormik } from "formik"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {
  statusTypes,
  messageTitle,
  vehicleTypes,
  seasonPasstSatusTypes,
} from "constants/common"
import { getRoles as onGetRoles } from "../../store/roles/actions"
import { getSettingData } from "../../store/settings/actions"
import { dateformat } from "config"
import moment from "moment-timezone"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import { mobileRegex, iuRegex,vehicleRegex } from "../../helpers/validator"
import Switch from "react-switch"
import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"
import DeleteModal from "components/Common/DeleteModal"
import Spinner from "components/Common/Spinner"

import {
  getUsers as onGetUsers,
  addNewUser as onAddNewUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
  blacklistUser as onBlacklistUser,
  clearMessage,
  resetData,
  getExportUser,
  resetExportFileData,
  clearStripeError,
  chargeUser as onChargeUser,
  priceBill as onPriceBill

} from "store/user/actions"
import { getSeasonPasses as onGetSeasonPasses } from "store/season-pass/actions"
import { isEmpty, map, orderBy } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//redux
import { useSelector, useDispatch } from "react-redux"
const defaultDate = moment()

const getColor = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return "danger"
  } else if (status == "Approved" || status == statusTypes.Available) {
    return "success"
  } else if (status == "Blacklist") {
    return "dark"
  } else if (status == 'Suspended') {
    return "secondary"
  } else {
    return "warning"
  }
}

const getSeason = seasonPass => {
  if (seasonPass) {
    return {
      value: seasonPass?.newSeason || seasonPass?._id || "",
      label: seasonPass?.seasonTitle || "",
    }
  }
  return null
}
const getRole = role => {
  if (role) {
    return {
      value: role?._id || "",
      label: role?.roleTitle || "",
    }
  }
  return null
}

const checkStatus = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return true
  } else {
    return false
  }
}

const getScheduleChangeDate = user => {
  if (!isEmpty(user)) {
    const schedule = Object.keys(user?.scheduled || []).find(
      el => el.updateField == "name"
    )
    if (schedule && !isEmpty(schedule)) {
      return schedule.dateScheduled
    }
  }
  return defaultDate
}
const getPMS = user => {
  if (!isEmpty(user)) {
    return {
      value: user?.primaryStation || "",
      label: user?.primaryStation || "",
    }
  }
  return null
}

const sizePerPage = 25;
const defaultStartDate = moment().startOf("M")
const defaultEndDate = moment()

const UserList = props => {
  const dispatch = useDispatch()
  const [user, setUser] = useState()
  const [amtCharged, setAmtCharged] = useState()
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" })
  const [vehicleType, setVehicleType] = useState(vehicleTypes.car)
  const [autoPay, setAutoPay] = useState(true)
  //const [seasonChangeDate, setSeasonChangeDate] = useState(user?.seasonExpiryDate)
  
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (user && user.name) || "",
      department: (user && user.department) || "",
      email: (user && user.email) || "",
      mobileNumber: (user && user.mobileNumber) || "",
      vehicleNumber: (user && user.vehicleNumber) || "",
      inVehicleUnit: (user && user.inVehicleUnit) || "",
      tempVehicleExpiryDate: (user && user.tempVehicle && user.tempVehicle.endDate) || null,
      tempVehicleNo: (user && user.tempVehicle && user.tempVehicle.tempVehicleNo) || "",
      tempInVehicleUnit: (user && user.tempVehicle && user.tempVehicle.tempInVehicleUnit) || "",
      tempVehicleReason: (user && user.tempVehicle && user.tempVehicle.reason) || "",
      scheduleChangeDate: convertUtcToLocal(
        getScheduleChangeDate(user || null)
      ),
      status: (user && user.status) || "",
      lastBillDate: (user && user.nextBillDate) || moment().add(1, "M").startOf("months"),
      seasonChangeDate: (user && user.seasonExpiryDate)|| moment().add(1, "M").startOf("months"),
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Please Enter Your Name")
        .min(5, "Must be at least 5 characters"),
      mobileNumber: Yup.string()
        .required("A valid Mobile Number is required")
        .matches(mobileRegex, "Invalid Mobile Number")
        .min(8, "Invalid Mobile Number")
        .max(8, "Invalid Mobile Number"),
      email: Yup.string()
        .required("Please Enter Your Email")
        .email("A valid Corporate Email is required")
        .max(255),
      vehicleNumber: Yup.string()
        .required("A valid Vehicle Number is required")
        .matches(vehicleRegex,"Invalid Vehicle Number" )
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      inVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
      tempVehicleNo: Yup.string()
        .matches(vehicleRegex,"Invalid Vehicle Number")
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      tempInVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
      tempVehicleExpiryDate: Yup.date().nullable(),
      seasonChangeDate: Yup.date().required("Please enter Date"),
    }),
    onSubmit: values => {
      if (isEmpty(selectedRole)) {
        setCustValidation({ validRole: false, validPMS: true, validSeason:true,validSeasonDate:true,validTempVehicleDate:true })
        return
      }
      if (isEmpty(selectedPMS)) {
        setCustValidation({ validRole: true, validPMS: false, validSeason:true,validSeasonDate:true,validTempVehicleDate:true   })
        return
      }
      if (isEmpty(selectedSeason)) {
        setCustValidation({ validRole: true, validPMS: true,validSeason:false,validSeasonDate:true,validTempVehicleDate:true  })
        return
      } 
      if (!isEmpty(values?.tempVehicleNo) && isEmpty(tempVehicleExpiryDate) ) {
        setCustValidation({...customValidation,validTempVehicleDate:false, })
        return
      } else if (isEmpty(values?.tempVehicleNo) )   {
        setCustValidation({...customValidation,validTempVehicleDate:true, })
      }        
/*       if (!isEdit && isEmpty(seasonChangeDate)) {
        setCustValidation({ validRole: true, validPMS: true,validSeason:true,validSeasonDate:false  })
        return
      }   */  
      if (isEdit) {
        let updateUser = {
          id: user.id,
          name: values.name,
          role: selectedRole?.value || "",
          corporateEmail: values.email,
          department: values.department,
          mobileNumber: values.mobileNumber,
          inVehicleUnit: values.inVehicleUnit,
          vehicleNumber: values.vehicleNumber,
          primaryStation: selectedPMS?.value || "",
          vehicleType,
          status: values.status,
          seasonExpiryDate:moment(values.seasonChangeDate),
          statusChangeReason: values.status === statusTypes.Rejected ? "Account Denied By Admin"
            : values.status === statusTypes.Removed ? "Account Terminated By Admin"
              : values.status === statusTypes.Blacklist ? "Account Blacklisted by Admin"
                : "",
          autoPay: autoPay || user?.autoPay,
/*           nextBillDate: moment(user.nextBillDate).diff(values.seasonStartDate, "days") > 0 ?
            moment(user.nextBillDate) : moment(values.seasonStartDate), */
        }

        /* if (selectedSeason?.value !== user?.approvedSeason?.newSeason) {

          const newSeasonType = (_seasonPasses || []).find(el => el._id == selectedSeason?.value)
          updateUser = {
            ...updateUser,
            approvedSeason: {
              status: statusTypes.Approved,
              seasonStart: moment(values.seasonChangeDate),
              newSeason: selectedSeason?.value,
              ...(newSeasonType ? { seasonType: newSeasonType?.seasonType } : {}),
              ...(newSeasonType ? { seasonTitle: newSeasonType?.seasonTitle } : {}),
            },
          }

        } */

        if (!isEmpty(values.tempVehicleNo)) {
          updateUser = {
            ...updateUser,
            tempVehicle: {
              startDate: convertDateToUtc(defaultDate),
              endDate: convertDateToUtc(tempVehicleExpiryDate),
              tempInVehicleUnit: values.tempInVehicleUnit,
              tempVehicleNo: values.tempVehicleNo,
              reason: values.tempVehicleReason,
              status: "Available",
            },
          }
        }
        // update user
        setLoading(true)
        dispatch(onUpdateUser(updateUser))
        validation.resetForm()
        setIsEdit(false)
      } else {
        const newUser = {
          name: values["name"],
          role: selectedRole?.value || "",
          season: selectedSeason?.value || "",
          corporateEmail: values["email"],
          department: values["department"],
          mobileNumber: values["mobileNumber"],
          vehicleNumber: values["vehicleNumber"],
          inVehicleUnit: values["inVehicleUnit"],
          tempVehicle: null,
          scheduled: null,
          transactions: null,
          status: "Approved",
          primaryStation: selectedPMS?.value || "",
          vehicleType,
          autoPay: autoPay,
          seasonStartDate: moment(values?.seasonChangeDate),

        }
        setLoading(true)
        // save new user
        dispatch(onAddNewUser(newUser))
      }
      toggle()
    },
  })

  const {
    users,
    roleList,
    message,
    pagination,
    error,
    seasonPassList,
    settingData,
    file,
    isStripeError,
    price,
    billMessage,
    billError,
  } = useSelector(state => ({
    users: state.users.userList,
    pagination: state.users.pagination,
    message: state.users.message,
    error: state.users.error,
    roleList: state.roles.roleList,
    seasonPassList: state.seasonPass?.seasonPassList || [],
    settingData: state.Settings.settingData,
    file: state.users.file,
    isStripeError: state.users.isStripeError,
    price: state.users.price,
    billMessage: state.users.message,
    billError: state.users.error,
  }))

  //const [userList, setUserList] = useState([])
  //const [pagination, setPagination] = useState({})
  const [modal, setModal] = useState(false)
  const [billEndDate, setBillEndDate] = useState(moment(user?.nextBillDate || moment().add(1, "M")).endOf("months"))
  const [billStartDate, setBillStartDate] = useState(moment(user?.nextBillDate || moment().add(1, "M")).startOf("months"))
  const [isEdit, setIsEdit] = useState(false)
  const [selectedRole, setSelectedRole] = useState(getRole(user?.role || null))
  const [selectedSeason, setSeason] = useState(getSeason(user?.approvedSeason || user?.season || null))
  const [tempVehicleExpiryDate, setTempVehicleExpiryDate] = useState(user?.tempVehicle?.endDate || null)
  
  const [currentPage, setCurrentPage] = useState(1)
  const [currentUser, setCurrentUser] = useState()
  const [filterStatus, setFilterStatus] = useState({
    value: "Approved",
    label: "Approved",
  })
  const [scheduleChange, setScheduleChange] = useState(false)
  const [selectedPMS, setPMS] = useState(getPMS(user))
  const [customValidation, setCustValidation] = useState({
    validRole: true,
    validPMS: true,
    validSeason: true,
    validSeasonDate: true,
    validTempVehicleDate: true,
  })
  const [loading, setLoading] = useState(false)
  const [primaryStations, setPrimaryStations] = useState([]);;

  const { SearchBar } = Search
  const onPageChangeHandler = (page, sizePerPage) => {
    dispatch(onGetUsers({ page: page, size: sizePerPage, startDate: startDate, endDate: endDate }))
  }
  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0,
    totalPages: pagination?.totalPages || 0,
    custom: true,
    onPageChange: setCurrentPage,
  }

  const [searchKey, setSearchKey] = useState("");
  const [filteredRes, setFilteredRes] = useState([]);

  useEffect(() => {
    if (users) {
      setFilteredRes(users);
    }
  }, [users]);

  useEffect(() => {
    // if (searchKey !== "") {
    //   const regex = new RegExp(searchKey.toLowerCase(), 'g');
    //   let filteredList = users?.filter((el)=>{
    //     if(regex.test(el?.userId.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.name.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.primaryStation.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.department.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.corporateEmail.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.mobileNumber.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.vehicleNumber.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.inVehicleUnit.toLowerCase())){
    //       return el;
    //     }
    //     if(regex.test(el?.season?.seasonTitle.toLowerCase())){
    //       return el;
    //     }
    //   });
    //   setFilteredRes(filteredList);
    //   setCurrentPage(1);
    //   if (filterStatus.value == "All") {
    //     dispatch(onGetUsers({ status: "", page: currentPage, size: sizePerPage, search: searchKey }))
    //   } else {
    //     dispatch(onGetUsers({ status: filterStatus.value, page: currentPage, size: sizePerPage, search: searchKey }))
    //   }
    // } else {
    //   // setFilteredRes(users);
    //   if (filterStatus.value == "All") {
    //     dispatch(onGetUsers({ status: "", page: currentPage, size: sizePerPage }))
    //   } else {
    //     dispatch(onGetUsers({ status: filterStatus.value, page: currentPage, size: sizePerPage }))
    //   }
    // }
    if (searchKey.length >= 2 || searchKey == "") {
      setCurrentPage(1);
      dispatch(onGetUsers({ status: filterStatus.value, page: currentPage, size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate }));
    }
  }, [searchKey]);

  
  useEffect(() => {
    let payload = {
      size: sizePerPage,
      search: searchKey,
    }
    if (startDate && endDate) {
      payload = {
        ...payload,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      }
    }
    dispatch(onGetUsers({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))

  }, [startDate, endDate])

  const handleReset = e => {
    setStartDate("")
    setEndDate("")
    setSearchKey("")
    dispatch(onGetUsers({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))

  }

  const defaultSorted = [
    {
      dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ]

  const userListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user._id}</>,
    },
    {
      text: "User ID",
      dataField: "userId",
      sort: true,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.name}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.role?.roleTitle || ""}</p>
        </>
      ),
    },
    {
      text: "Employment Details",
      dataField: "primaryStation",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.primaryStation}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.department || ""}</p>
        </>
      ),
    },
    {
      text: "Contact Details",
      dataField: "mobileNumber",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.mobileNumber}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.corporateEmail || ""}</p>
        </>
      ),
    },
    {
      text: "Vehicle Details",
      dataField: "vehicleNumber",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.vehicleNumber}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.inVehicleUnit || ""}</p>
        </>
      ),
    },
    {
      dataField: "season",
      text: "Season Selected",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <p className="text-muted mb-0">{user?.season?.seasonTitle || ""}</p>
          <p className="text-muted mb-0">{user?.seasonExpiryDate?convertUtcToLocal(user?.seasonExpiryDate) : ""}</p>
        </>
      ),
    },
    {
      dataField: "updatedAt",
      text: "Last Active / Status Change",
      sort: true,
      formatter: (cellContent, user) => {
        let lastDate =
          !_.isUndefined(user?.lastActivityAt) && user?.lastActivityAt
            ? moment(user.lastActivityAt).fromNow()
            : null;
        let statusChanged =
          !_.isUndefined(user?.statusChangeDate) && user?.statusChangeDate
            ? moment(user.statusChangeDate).fromNow()
            : null;
        // return <>{lastDate}</>
        return <><p className="text-muted mb-0">Last parked: {lastDate}</p><p className="text-muted mb-0">Status changed: {statusChanged}</p></>
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, user) => (
        <Badge className={"bg-" + getColor(user?.status)}>{user?.status}</Badge>
      ),
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <div className="d-flex gap-3">
          <Link
            className="text-danger"
            to="#"
            style={{
              opacity: user?.status === statusTypes.Approved && user?.seasonType == "Monthly" ? 5 : "0.4",
              pointerEvents: user?.status === statusTypes.Approved && user?.seasonType == "Monthly" ? "auto" : "none",
            }}
          >
            <i
              className="mdi mdi-credit-card font-size-24"
              id="edittooltip"
              onClick={e =>  handleChargeUserClick(user)}
              data-toggle="tooltip"
              data-placement="top"
              title="Charge User"
            ></i>
          </Link>
          <Link
            className="text-primary"
            to="#"
            style={{
              opacity: checkStatus(user?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(user?.status) ? "none" : "auto",
            }}
          >
            <i
              className="mdi mdi-account-edit font-size-24"
              id="edittooltip"
              onClick={e => handleUserClick(user)}
              data-toggle="tooltip"
              data-placement="top"
              title="Update User"
            ></i>
          </Link>
          {/* <Link
            className={
              user?.status == "Blacklist" ? "text-success" : "text-black"
            }
            to="#"
            style={{
              opacity: checkStatus(user?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(user?.status) ? "none" : "auto",
            }}
          >
            <i
              className={
                user?.status == "Blacklist"
                  ? "mdi mdi-account-arrow-left font-size-24"
                  : "mdi mdi-account-cancel font-size-24"
              }
              id="edittooltip"
              onClick={e => handleBlockClick(user)}
              data-toggle="tooltip"
              data-placement="top"
              title={
                user?.status == "Blacklist"
                  ? "Reapprove User"
                  : "Blacklist User"
              }
            ></i>
          </Link> */}
          <Link
            className="text-danger"
            to="#"
            style={{
              opacity: checkStatus(user?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(user?.status) ? "none" : "auto",
            }}
          >
            <i
              className="mdi mdi-account-minus font-size-24"
              id="deletetooltip"
              onClick={() => { setCurrentUser(user); onClickDelete(user) }}
              data-toggle="tooltip"
              data-placement="top"
              title="Remove User"
            ></i>
          </Link>
        </div>
      ),
    },
  ]

  useEffect(() => {
    setLoading(true)
    dispatch(getSettingData())
    dispatch(onGetUsers({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))
    dispatch(onGetRoles({ status: [seasonPasstSatusTypes.Available] }))
    dispatch(
      onGetSeasonPasses({
        status: statusTypes.Available,
        vehicletype: vehicleType,
      })
    )
    return function cleanup() {
      dispatch(resetData())
    }
  }, [])

  useEffect(() => {
    dispatch(onGetUsers({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))
  }, [currentPage])

  useEffect(() => {
    dispatch(
      onGetSeasonPasses({
        status: statusTypes.Available,
        vehicletype: vehicleType,
      })
    )
  }, [vehicleType])

  useEffect(() => {
    if (settingData["cpfProperties"]) {
      const { cpfBuilding } = settingData["cpfProperties"]
      const list = !isEmpty(cpfBuilding) ? cpfBuilding.split(`,`) : []
      setPrimaryStations(list)
    }
  }, [settingData])

  useEffect(() => {
    setIsEdit(false)
    // onPaginationPageChange(currentPage)
  }, [filteredRes])

  useEffect(() => {
    if (!isEmpty(filteredRes)) {
      setLoading(false)
    } else {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
    if (!isEmpty(filteredRes) && !!isEdit) {
      setIsEdit(false)
    }
  }, [filteredRes])

  useMemo(() => {
    if (message) {
      message == "PDF file content not found." ||
        message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      dispatch(onGetUsers({ status: filterStatus.value, search: searchKey, page: currentPage, size: sizePerPage, startDate: startDate, endDate: endDate }))
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }

  }, [dispatch, message]);

  useEffect(() => {
    if (isStripeError) {
      toastr.error("Error communicating with Stripe", "Stripe Error");
      setTimeout(() => {
        dispatch(clearStripeError());
      }, 300)
    }
  }, [isStripeError]);

  useMemo(() => {
    if (!isEmpty(error)) {
      setLoading(false)
      if (error?.message == 'Unable to process to payment') {
        toastr.error(error.message, messageTitle)
        setTimeout(() => {
          // handleBlockClick(currentUser)
          setUser({ ...currentUser, action: "deleteBlacklist" })
          setDeleteModal(true)
        }, 300)
      }
      toastr.error(error.message||error, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  useMemo(() => {
    if (billMessage) {
      toastr.success(billMessage, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }

  }, [dispatch, billMessage]);


  useMemo(() => {
    if (!isEmpty(billError)) {
      setLoading(false)
      toastr.error(billError.message || billError, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, billError])

  useEffect(() => {
    if (file) {
      // Call to download file
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file])

  const toggle = () => {
    setModal(!modal)
  }

  const handleUserClick = arg => {
    const user = arg
    setUser({
      ...user,
      id: user._id,
      name: user.name,
      seasonType: user.seasonType,
      email: user.corporateEmail,
      department: user.department,
      mobileNumber: user.mobileNumber,
      vehicleNumber: user.vehicleNumber,
      inVehicleUnit: user.inVehicleUnit,
      autoPay: user?.autoPay,
    })
    setAutoPay(user?.autoPay);
    setSelectedRole(getRole(user?.role || null))
    setSeason(getSeason(user?.approvedSeason || user?.season || null))
    setTempVehicleExpiryDate(user?.tempVehicle?.endDate);
    //setSeasonChangeDate(user?.seasonExpiryDate|| null)
    setIsEdit(true)
    setScheduleChange(user?.scheduled ? true : false)
    setPMS(getPMS(user))
    if (user.vehicleType == vehicleTypes.bike) {
      setVehicleType(vehicleTypes.bike)
    } else {
      setVehicleType(vehicleTypes.car)
    }
    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = user => {
    setUser({ ...user, action: "delete" })
    setDeleteModal(true)
  }

  // Used to handle the Charge User action
  const handleChargeUserClick = user => {
    setUser({ ...user, action: "charge" })
    setAmtCharged({calnetvalue:user?.season?.pricing?.$numberDecimal,seasonChangeValue:0});
    setBillStartDate(moment(user?.nextBillDate || moment().add(1, "M")).startOf("months"));
    setBillEndDate(moment(user?.nextBillDate || moment().add(1, "M")).endOf("months"));

    setDeleteModal(true)
  }

  const handleBlockClick = user => {
    if (user?.status == "Blacklist") {
      setUser({ ...user, action: "approve" })
    } else {
      setUser({ ...user, action: "blacklist" })
    }
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    setLoading(true)
    if (user.action == "blacklist" || user?.action == "deleteBlacklist") {
      let updatedUser = {
        ...user,
        statusChangeReason: "Blacklisted by Admin",
      }
      dispatch(onBlacklistUser(updatedUser))
    } else if (user.action == "approve") {
      const updateUser = {
        id: user._id,
        status: statusTypes.Approved,
      }
      dispatch(onUpdateUser(updateUser))
    } else if (user.action == 'charge') { 
      const updateUser = {
        ...user,
        billAmount: amtCharged?.calnetvalue,
        seasonChangeValue: amtCharged?.seasonChangeValue,
        billEndDate: billEndDate,
        billStartDate: billStartDate,
      }
      dispatch(onChargeUser(updateUser))
    } else {
      let updatedUser = {
        ...user,
        statusChangeReason: "Removed By Admin",
      }
      dispatch(onDeleteUser(updatedUser))
    }
    //onPaginationPageChange(currentPage)
    setDeleteModal(false)
  }

  // Used to handle the Charge User date change
  const handlStartDateChange = useCallback((id, unitPrice, billStartDate, billEndDate) => {
    setBillStartDate(billStartDate);
    const pricePayload = { id, unitPrice, billStartDate, billEndDate, };
    dispatch(onPriceBill(pricePayload));
  })
  const handlEndDateChange = useCallback((id, unitPrice, billStartDate, billEndDate) => {
    setBillEndDate(billEndDate);
    const pricePayload = { id, unitPrice, billStartDate, billEndDate, };
    dispatch(onPriceBill(pricePayload));
  })

  useEffect(() => {
    if (price) {
      setAmtCharged(price);
    }
  }, [price]);

  const resetForm = () => {
    setUser(null)
    setSelectedRole(null)
    setSeason(null)
    setPMS(null)
    setScheduleChange(false)
    setVehicleType(vehicleTypes.car)
  }

  const handleUserClicks = () => {
    validation.resetForm()
    resetForm()
    setIsEdit(false)
    toggle()
  }

  const handleFilter = e => {
    setCurrentPage(1);
    setFilterStatus(e);
    // if (e.value == "All") {
    //   dispatch(onGetUsers({ status: "", page: currentPage, size: sizePerPage }))
    // } else {
    //   dispatch(onGetUsers({ status: e.value, page: currentPage, size: sizePerPage }))
    // }
  }

  // Runs when filterStatus is updated, which is from handleFilter function
  useEffect(() => {
    dispatch(onGetUsers({ page: currentPage, size: sizePerPage, status: filterStatus.value, search: searchKey, startDate: startDate, endDate: endDate }));
  }, [filterStatus])

  const setDownloadType = () => {
    const exportPayload = {
      // file_type: "csv",
      file_type: fileType.value,
      status: filterStatus.value, search: searchKey, startDate: startDate, endDate: endDate 
    }
    dispatch(getExportUser(exportPayload))
  }

  const handleExport = fileData => {
    // const fileName = `user_post_pms_data` + new Date().getTime() + `.csv`
    const fileName =
      `user_post_pms_data` +
      new Date().getTime() +
      `.${fileType.value.toLowerCase()}`
    // const downloadType = "application/vnd.ms-excel"
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? // ? "application/vnd.ms-excel"
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSelectType = e => {
    setFileType(e)
  }

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  const keyField = "_id"
  const roleOptions = (roleList || []).map(el => ({
    value: el._id,
    label: el.roleTitle,
  }))
  const _seasonPasses = (seasonPassList || []).filter(el => {
    if (selectedRole) {
      return el.roleApplicable.includes(selectedRole.value)
    } else {
      return true
    }
  })

  const seasonTypeOptions = map(_seasonPasses || [], el => {
    return {
      value: el._id,
      label: el.seasonTitle,
      type: el.seasonType,
    }
  })
  delete statusTypes.Offline
  let statusTypeOptions = map(statusTypes, (key, i) => {
    return {
      value: `${key}`,
      label: `${statusTypes[key]}`,
    }
  })
  statusTypeOptions.unshift({ value: "All", label: "All" })

  const stationOptions = map(primaryStations, el => {
    return {
      value: `${el.trim()}`,
      label: `${el.trim()}`,
    }
  })

  let rows = []
  if (user) {
    rows.push(user.id)
  }

  const _expiryDate = tempVehicleExpiryDate
    ? moment(convertUtcToLocal(tempVehicleExpiryDate)).format(
      dateformat.default
    )
    : ""

  const _scheduleChangeDate = validation.values.scheduleChangeDate
    ? moment(convertUtcToLocal(validation.values.scheduleChangeDate)).format(
      dateformat.default
    )
    : ""

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  const handleTableChange = () => { }

  return (
    <React.Fragment>
      <Spinner loading={loading} />
      <DeleteModal
        show={deleteModal}
        text={
          user?.action == "blacklist" || user?.action == "deleteBlacklist"
            ? "Yes, blacklist it!"
            : user?.action == "approve"
              ? "Yes, approve it!"
              : user?.action == "charge"
                ? "Yes, charge user"
                : "Yes, delete it!" // Text changes to this if action == 'delete'
        }
        title={user?.action == "charge" ? `Are you sure to charge ${user?.name}?` : user?.action == "deleteBlacklist" && currentUser?._id == user?._id ? `Pending Bill Not Processed` : ''}
        icon={
          user?.action == "blacklist"
            ? "mdi mdi-account-cancel"
            : user?.action == "approve"
              ? "mdi mdi-account-arrow-left"
              : user?.action == "charge"
                ? "mdi mdi-credit-card"
                : "mdi mdi-account-minus"
        }
        iconColor={
          user?.action == "blacklist"
            ? "text-black"
            : user?.action == "approve"
              ? "text-success"
              : "text-danger" // action == 'charge' will have text-danger too
        }
        bodytext={
          user?.action == "blacklist"
            ? `Blacklist User: ${user?.name}!`
            : user?.action == "approve"
              ? `Approve User: ${user?.name}!`
              : user?.action == "charge"
                ? `Charge User: ${user?.name}!`
                : `Delete User: ${user?.name}!`
        }
        bodyText={
          user?.action == "deleteBlacklist" && currentUser?._id == user?._id ? "Payment for Pending Bill(s) Process Failed, Do you want to Blacklist user instead" : ''
        }
        childComponent={ // For charging user action
          user?.action == "charge" ? (
            <div>
              <Row><h4>{"You won't be able to revert this!"}</h4></Row>
              <Row><h5>{"Current Bill End Date: " + moment(user?.nextBillDate).add(-1, "days").format('DD MMM YYYY')}</h5></Row>
              <Row className="justify-content-md-center">
                <Col md={4} className="p-0">
                  <h5 className="mt-2 ml-2">Bill start date</h5>
                </Col>
                <Col md={4} className="p-0">
                  <input
                    className="form-control"
                    type="date"
                    placeholder={
                      "DD-MM-YYYY"
                    }
                    // min={new Date(user?.data?.season?.seasonType === "Monthly" ? user?.data?.nextBillDate : null)}
                    // min = {moment(user?.season?.seasonType === "Monthly" ? user?.nextBillDate : moment()).format('YYYY-MM-DD')}
                    name="billStartDate"
                    onChange={e => handlStartDateChange(user?._id, parseFloat(user?.season?.pricing?.$numberDecimal).toFixed(2), e.target.value, moment(billEndDate).format("YYYY-MM-DD"))}
                    onBlur={e => handlStartDateChange(user?._id, parseFloat(user?.season?.pricing?.$numberDecimal).toFixed(2), e.target.value, moment(billEndDate).format("YYYY-MM-DD"))}
                    value={moment(billStartDate).format("YYYY-MM-DD")}
                  />
                </Col>
              </Row>
              <Row className="justify-content-md-center">
                <Col md={4} className="p-0">
                  <h5 className="mt-2 ml-2">Bill end date</h5>
                </Col>
                <Col md={4} className="p-0">
                  <input
                    className="form-control"
                    type="date"
                    placeholder={
                      "DD-MM-YYYY"
                    }
                    // min={new Date(user?.data?.season?.seasonType === "Monthly" ? user?.data?.nextBillDate : null)}
                    // min = {moment(user?.season?.seasonType === "Monthly" ? user?.nextBillDate : moment()).format('YYYY-MM-DD')}
                    name="billEndDate"
                    onChange={e => handlEndDateChange(user?._id, parseFloat(user?.season?.pricing?.$numberDecimal).toFixed(2), moment(billStartDate).format("YYYY-MM-DD"), e.target.value)}
                    onBlur={e => handlEndDateChange(user?._id, parseFloat(user?.season?.pricing?.$numberDecimal).toFixed(2), moment(billStartDate).format("YYYY-MM-DD"), e.target.value)}
                    value={moment(billEndDate).format("YYYY-MM-DD")}
                  />
                </Col>
              </Row>
              <Row>
                {/* TODO: make amount charged dynamic */}
                <h5 className="mt-2">Net Amount before GST: ${amtCharged?.calnetvalue}</h5>
              </Row>
            </div>
          ) : null
        }
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={userListColumns}
                data={filteredRes || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <ToolkitProvider
                      keyField={keyField}
                      data={filteredRes || []}
                      columns={userListColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="">
                              <Select
                                placeholer={"Select status"}
                                name={"statusType"}
                                value={filterStatus}
                                onChange={e => {
                                  handleFilter(e)
                                }}
                                options={statusTypeOptions}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col md="">
                              <input
                                className="form-control"
                                type="date"
                                value={startDate}
                                id="startDate"
                                name="startDate"
                                onChange={e => setStartDate(e.target.value)}
                                onBlur={e => setStartDate(e.target.value)}
                              />
                            </Col>
                            <Col md="">
                              <input
                                className="form-control"
                                type="date"
                                value={endDate}
                                id="endDate"
                                name="endDate"
                                onChange={e => setEndDate(e.target.value)}
                                onBlur={e => setEndDate(e.target.value)}
                              />
                            </Col>   
                            <Col sm="">
                              <Button
                                color="primary"
                                className="font-16 btn-block btn btn-primary"
                                onClick={e => {
                                  toolkitProps.searchProps.onSearch("")
                                  setTimeout(() => {
                                    handleReset(e)
                                  }, 200)
                                }}
                              >
                                Reset
                              </Button>
                            </Col>
                            <Col sm="">
                              <div className="search-box ms-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  {/* <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" /> */}
                                  <input
                                    id="search-bar-0"
                                    type="text"
                                    className="form-control "
                                    placeholder="Search"
                                    value={searchKey}
                                    onChange={e => setSearchKey(e.target.value)}
                                  />

                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="auto">
                              <div className="text-sm-end d-flex gap-2">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleUserClicks}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New User
                                </Button>
                                <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholder={"Select Type"}
                                    name={"File Type"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div>
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={() => setDownloadType()}
                                >
                                  <i className="bx bx-upload me-1" />
                                  Export
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  // selectRow={{
                                  //   mode: "checkbox",
                                  //   selected: rows,
                                  // }}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                  onTableChange={handleTableChange}
                                />

                                <Modal
                                  isOpen={modal}
                                  toggle={toggle}
                                  className={"modal-lg"}
                                >
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit ? "Update User" : "Add New User"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <Form
                                      onSubmit={e => {
                                        e.preventDefault()
                                        validation.handleSubmit()
                                        return false
                                      }}
                                    >
                                      <Row form>
                                        <Col xs={12}>
                                          {/* {isEdit && (
                                            <Col md={6}>
                                              <div className="mb-3">
                                                <Label className="form-label">
                                                  Schedule Change
                                                </Label>
                                                <Row className="mb-2">
                                                  <Col
                                                    md={2}
                                                    className="pr-0 pt-1"
                                                  >
                                                    <Switch
                                                      checked={scheduleChange}
                                                      onColor="#626ed4"
                                                      onChange={() =>
                                                        setScheduleChange(
                                                          !scheduleChange
                                                        )
                                                      }
                                                      uncheckedIcon={
                                                        <OffSymbol text="Off" />
                                                      }
                                                      checkedIcon={
                                                        <OnSymbol text="On" />
                                                      }
                                                    />
                                                  </Col>
                                                  {scheduleChange && (
                                                    <Col
                                                      md={10}
                                                      className="pl-0"
                                                    >
                                                      <input
                                                        className="form-control"
                                                        type="date"
                                                        defaultValue={
                                                          _scheduleChangeDate
                                                        }
                                                        id="scheduleChangeDate"
                                                        name="scheduleChangeDate"
                                                        min={moment().format(
                                                          "YYYY-MM-DD"
                                                        )}
                                                        onChange={
                                                          validation.handleChange
                                                        }
                                                        onBlur={
                                                          validation.handleBlur
                                                        }
                                                        invalid={
                                                          validation.touched
                                                            .scheduleChangeDate &&
                                                          validation.errors
                                                            .scheduleChangeDate
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      {validation.touched
                                                        .scheduleChangeDate &&
                                                      validation.errors
                                                        .scheduleChangeDate ? (
                                                        <FormFeedback type="invalid">
                                                          {
                                                            validation.errors
                                                              .scheduleChangeDate
                                                          }
                                                        </FormFeedback>
                                                      ) : null}
                                                    </Col>
                                                  )}
                                                </Row>
                                              </div>
                                            </Col>
                                          )} */}
                                          <div className="mb-3">
                                            <Row>
                                              <Col md={6}>
                                                <label className="form-label">
                                                  Role*
                                                </label>
                                                <Select
                                                  name="role"
                                                  value={selectedRole}
                                                  onChange={e => {
                                                    setCustValidation({
                                                      ...customValidation,
                                                      validRole: true,
                                                    })
                                                    setSelectedRole(e)
                                                  }}
                                                  options={roleOptions}
                                                  classNamePrefix="select2-selection"
                                                />
                                                {!customValidation.validRole && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                  >
                                                    Please select Role
                                                  </div>
                                                )}
                                              </Col>
                                              <Col md={6}>
                                                <Label className="form-label">
                                                  Primary Location*
                                                </Label>
                                                <Select
                                                  name={"primaryStation"}
                                                  value={selectedPMS}
                                                  onChange={e => {
                                                    setCustValidation({
                                                      ...customValidation,
                                                      validPMS: true,
                                                    })                                                    
                                                    setPMS(e)
                                                  }}
                                                  options={stationOptions}
                                                  classNamePrefix="select2-selection"
                                                />

                                                {!customValidation.validPMS && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                  >
                                                    Please select primary
                                                    station
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                          <div className="mb-3">
                                            <Row>
                                              <Col md={7}>
                                                <Label className="form-label">
                                                  Department / Company Name
                                                </Label>
                                                <Input
                                                  name="department"
                                                  //label="Department / Tenanted Site"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .department || ""
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .department &&
                                                      validation.errors.department
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched
                                                  .department &&
                                                  validation.errors.department ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .department
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </Col>
                                              <Col md={5}>
                                                <Label className="form-label">
                                                  Name*
                                                </Label>
                                                <Input
                                                  name="name"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values.name || ""
                                                  }
                                                  invalid={
                                                    validation.touched.name &&
                                                      validation.errors.name
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched.name &&
                                                  validation.errors.name ? (
                                                  <FormFeedback type="invalid">
                                                    {validation.errors.name}
                                                  </FormFeedback>
                                                ) : null}
                                              </Col>
                                            </Row>
                                          </div>

                                          <div className="mb-3">
                                            <Row>
                                              <Col md={7}>
                                                <Label className="form-label">
                                                  Email*
                                                </Label>
                                                <Input
                                                  name="email"
                                                  label="Email"
                                                  type="email"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values.email ||
                                                    ""
                                                  }
                                                  invalid={
                                                    validation.touched.email &&
                                                      validation.errors.email
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                {validation.touched.email &&
                                                  validation.errors.email ? (
                                                  <FormFeedback type="invalid">
                                                    {validation.errors.email}
                                                  </FormFeedback>
                                                ) : null}
                                              </Col>
                                              <Col md={5}>
                                                <Label className="form-label">
                                                  Mobile Number*
                                                </Label>
                                                <Row>
                                                  <Col sm={12}>
                                                    <InputGroup className="mb-2">
                                                      <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                          +65
                                                        </span>
                                                      </div>
                                                      <Input
                                                        name="mobileNumber"
                                                        label="mobileNumber"
                                                        type="text"
                                                        onChange={
                                                          validation.handleChange
                                                        }
                                                        onBlur={
                                                          validation.handleBlur
                                                        }
                                                        value={
                                                          validation.values
                                                            .mobileNumber || ""
                                                        }
                                                        invalid={
                                                          validation.touched
                                                            .mobileNumber &&
                                                            validation.errors
                                                              .mobileNumber
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      {validation.touched
                                                      .mobileNumber &&
                                                      validation.errors
                                                        .mobileNumber ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .mobileNumber
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                    </InputGroup>
                                                    
                                                  </Col>
                                                </Row>
                                              </Col>
                                            </Row>
                                          </div>
                                          <div className="mb-3">
                                            <h5 className="font-size-14 mb-3 mt-4">
                                              Primary Vehicle
                                            </h5>
                                          </div>
                                          <div className="mb-3">
                                            <Row>
                                              <Col md={3}>
                                                <Row>
                                                  <Col>
                                                    <div className="form-check mt-4 mb-1">
                                                      <input
                                                        type="radio"
                                                        id="customRadio1"
                                                        name="customRadio"
                                                        className="form-check-input"
                                                        defaultChecked={
                                                          vehicleType ==
                                                          vehicleTypes.car
                                                        }
                                                        onChange={e =>
                                                          setVehicleType(
                                                            vehicleTypes.car
                                                          )
                                                        }
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor="customRadio1"
                                                      >
                                                        Car
                                                      </label>
                                                    </div>
                                                  </Col>
                                                  <Col>
                                                    <div className="form-check mt-4">
                                                      <input
                                                        type="radio"
                                                        id="customRadio2"
                                                        name="customRadio"
                                                        className="form-check-input"
                                                        defaultChecked={
                                                          vehicleType ==
                                                          vehicleTypes.bike
                                                        }
                                                        onChange={e =>
                                                          setVehicleType(
                                                            vehicleTypes.bike
                                                          )
                                                        }
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor="customRadio2"
                                                      >
                                                        Bike
                                                      </label>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col md={4}>
                                                <Label className="form-label">
                                                  Vehicle Number*
                                                </Label>
                                                <Input
                                                  name="vehicleNumber"
                                                  label="vehicleNumber"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .vehicleNumber || ""
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .vehicleNumber &&
                                                      validation.errors
                                                        .vehicleNumber
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                <span>Use <b>A00A</b> for guest invitees</span>
                                                {validation.touched
                                                  .vehicleNumber &&
                                                  validation.errors
                                                    .vehicleNumber ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .vehicleNumber
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </Col>
                                              <Col md={5}>
                                                <Label className="form-label">
                                                  In Vehicle Unit*
                                                </Label>
                                                <Input
                                                  name="inVehicleUnit"
                                                  label="inVehicleUnit"
                                                  type="text"
                                                  onChange={
                                                    validation.handleChange
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={
                                                    validation.values
                                                      .inVehicleUnit || ""
                                                  }
                                                  invalid={
                                                    validation.touched
                                                      .inVehicleUnit &&
                                                      validation.errors
                                                        .inVehicleUnit
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                <span>Use <b>0000000000</b> for guest invitees</span>
                                                {validation.touched
                                                  .inVehicleUnit &&
                                                  validation.errors
                                                    .inVehicleUnit ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .inVehicleUnit
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </Col>
                                            </Row>
                                          </div>
                                          {isEdit && (
                                            <>
                                              <div className="mb-3">
                                                <h5 className="font-size-14 mb-3 mt-4">
                                                  Temporary Vehicle
                                                </h5>
                                              </div>
                                              <div className="mb-3">
                                                <Row>
                                                  <Col md={4}>
                                                    <Label className="form-label">
                                                      Vehicle Number*
                                                    </Label>
                                                    <Input
                                                      name="tempVehicleNo"
                                                      label="tempVehicleNo"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .tempVehicleNo || ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .tempVehicleNo &&
                                                          validation.errors
                                                            .tempVehicleNo
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched
                                                      .tempVehicleNo &&
                                                      validation.errors
                                                        .tempVehicleNo ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .tempVehicleNo
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                  <Col md={8}>
                                                    <Label className="form-label">
                                                      In Vehicle Unit*
                                                    </Label>
                                                    <Input
                                                      name="tempInVehicleUnit"
                                                      label="tempInVehicleUnit"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .tempInVehicleUnit ||
                                                        ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .tempInVehicleUnit &&
                                                          validation.errors
                                                            .tempInVehicleUnit
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {validation.touched
                                                      .tempInVehicleUnit &&
                                                      validation.errors
                                                        .tempInVehicleUnit ? (
                                                      <FormFeedback type="invalid">
                                                        {
                                                          validation.errors
                                                            .tempInVehicleUnit
                                                        }
                                                      </FormFeedback>
                                                    ) : null}
                                                  </Col>
                                                </Row>
                                              </div>
                                              <div className="mb-3">
                                                <Row>
                                                  <Col md={4}>
                                                    <Label className="form-label">
                                                      Expiry Date*
                                                    </Label>
                                                    <input
                                                      className="form-control"
                                                      type="date"
                                                      placeholder={"DD-MM-YYYY"}
                                                      defaultValue={_expiryDate}
                                                      min={moment().format(
                                                        "YYYY-MM-DD"
                                                      )}
                                                      id="tempVehicleExpiryDate"
                                                      name="tempVehicleExpiryDate"
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      onChange={e => {
                                                        setCustValidation({
                                                          ...customValidation,
                                                          validTempVehicleDate: true,
                                                        })
                                                        setTempVehicleExpiryDate(e.target.value)
                                                      }}
                                                    />
                                                    {!customValidation.validTempVehicleDate && (
                                                          <div
                                                            className="invalid-feedback"
                                                            style={{ display: "block" }}
                                                          >
                                                            Please select expiry Date
                                                          </div>
                                                        )}
                                                      
                                                  </Col>
                                                  <Col md={8}>
                                                    <Label className="form-label">
                                                      Reason
                                                    </Label>
                                                    <textarea
                                                      name="tempVehicleReason"
                                                      className="form-control"
                                                      id="tempVehicleReason"
                                                      rows="3"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .tempVehicleReason ||
                                                        ""
                                                      }
                                                    ></textarea>
                                                  </Col>
                                                </Row>
                                              </div>
                                              <div className="mb-3"></div>
                                            </>
                                          )}
                                        </Col>
                                      </Row>
                                      <div className="mb-3">
                                        <h5 className="font-size-14 mb-3 mt-4">
                                          Season
                                        </h5>
                                      </div>
                                      <div className="mb-3">
                                        <Row>
                                          <Col md={2}>
                                            <Label className="form-check-label">
                                              Auto Pay
                                            </Label>
                                            <Switch
                                              checked={autoPay}
                                              onColor="#626ed4"
                                              onChange={e => {
                                                setAutoPay(!autoPay)
                                              }}
                                              uncheckedIcon={
                                                <OffSymbol text="Off" />
                                              }
                                              checkedIcon={
                                                <OnSymbol text="On" />
                                              }
                                            />
                                          </Col>
                                          <Col md={7}>
                                            <label className="form-label">
                                              Season Type
                                            </label>
                                            <Select
                                              name={"seasonType"}
                                              value={selectedSeason}
                                              onChange={e => {
                                                setCustValidation({
                                                  ...customValidation,
                                                  validSeason: true,
                                                })
                                                setSeason(e)
                                              }}
                                              options={seasonTypeOptions}
                                              classNamePrefix="select2-selection"
                                              isDisabled={isEdit}
                                            />
                                            {!customValidation.validSeason && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                  >
                                                    Please select season
                                                  </div>
                                                )}
                                          </Col>
                                          <Col md={3}>
                                            <Label className="form-label" htmlFor="seasonChangeDate">
                                            {isEdit?"Expiry Date":"Start Date"}
                                            </Label>
                                            <input
                                              className="form-control"
                                              type="date"
                                              placeholder={
                                                "DD-MM-YYYY"
                                              }
                                              value={moment(convertUtcToLocal(validation.values.seasonChangeDate))
                                                .format("YYYY-MM-DD")
                                              }                                
                                              name="seasonChangeDate"
                                              onChange={
                                                validation.handleChange
                                              }
                                              onBlur={
                                                validation.handleBlur
                                              }
                                              invalid={
                                                (validation.touched.seasonChangeDate &&
                                                  validation.errors.seasonChangeDate)
                                                  ? true : false
                                              }
                                            />
                                            {(validation.touched.seasonChangeDate &&
                                             validation.errors.seasonChangeDate) ? (
                                              <FormFeedback type="invalid">
                                                {
                                                  validation.errors
                                                    .seasonChangeDate
                                                }
                                              </FormFeedback>
                                            ) : null}
                                          </Col>

                                        </Row>
                                      </div>

                                      <Row>
                                        <Col className="mt-4">
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              {!!isEdit
                                                ? "Update User"
                                                : "Add New User"}
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  )
                }}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withRouter(UserList)
